import type { PartnerConfig } from "@/content/partners/types"

export const FEIJOADA_SOLIDARIA_PARTNER_SLUG = "feijoada-solidaria"

export const FEIJOADA_SOLIDARIA_LOGO_PATH = "/brand/logo-feijoada-da-amr.png"

export const FEIJOADA_SOLIDARIA_CADASTRO_HREF = `/cadastro?partner=${FEIJOADA_SOLIDARIA_PARTNER_SLUG}`

/**
 * Corte de novas adesões: 23/10/2026 19:00 America/Sao_Paulo (antes do evento).
 * `event_date` em metadata continua sendo o dia da retirada, não este corte.
 */
export const FEIJOADA_SOLIDARIA_ACTIVE_UNTIL = "2026-10-23T22:00:00.000Z"

/**
 * Campanha de origem encerrada para cadastro novo. O kit da Feijoada da AMR é operação manual.
 * `benefitMode: none` — não sobe faixa nem abre fila de cupom de evento.
 * Quem já tem `partner_attributions` permanece: o vínculo é write-once e não é reescrito aqui.
 */
export const feijoadaSolidariaPartnerConfig: PartnerConfig = {
  slug: FEIJOADA_SOLIDARIA_PARTNER_SLUG,
  name: "Feijoada Solidária",
  fullName: "Feijoada da AMR",
  logoPath: FEIJOADA_SOLIDARIA_LOGO_PATH,
  benefitMode: "none",
  isActive: false,
  activeUntil: FEIJOADA_SOLIDARIA_ACTIVE_UNTIL,
  partnershipMention: "Parceria Feijoada da AMR",
  metadata: {
    kind: "campaign_origin",
    organization: "AMR",
    website: "https://amr.org.br/conhecaaamr/",
    event_date: "2026-10-24",
    gift: "kit_feijoada_duas_pessoas",
  },
}

/** LP e CTAs só oferecem cadastro enquanto a campanha aceita adesão nova. */
export function feijoadaSolidariaCadastroHref(now = Date.now()): string | null {
  const config = feijoadaSolidariaPartnerConfig
  if (!config.isActive) return null
  if (config.activeUntil) {
    const until = new Date(config.activeUntil).getTime()
    if (Number.isFinite(until) && now > until) return null
  }
  return FEIJOADA_SOLIDARIA_CADASTRO_HREF
}
